import { render, staticRenderFns } from "./SuggestedResources.vue?vue&type=template&id=356e472e"
import script from "./SuggestedResources.vue?vue&type=script&lang=ts"
export * from "./SuggestedResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356e472e')) {
      api.createRecord('356e472e', component.options)
    } else {
      api.reload('356e472e', component.options)
    }
    module.hot.accept("./SuggestedResources.vue?vue&type=template&id=356e472e", function () {
      api.rerender('356e472e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/requestDetails/SuggestedResources.vue"
export default component.exports